var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 35C0 54.33 15.67 70 35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0C15.67 0 0 15.67 0 35Z",
    fill: "#81061A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.24 33.63H21.64V34.51H29.24V33.63ZM29.49 30.07H21.27C20.64 30.07 20.12 30.59 20.12 31.23V32.97H30.65V31.23C30.65 30.59 30.13 30.07 29.49 30.07ZM29.9 39.54V52.58H20.98V39.54H29.9ZM28.99 35.17H21.88C20.29 35.17 19 36.48 19 38.07V53.81C19 54.77 19.78 55.55 20.73 55.55H30.14C31.09 55.55 31.87 54.77 31.87 53.81V38.08C31.88 36.48 30.58 35.17 28.99 35.17ZM35.63 30.37H44.5701V51.53H35.63V30.37ZM33.05 26.46H47.16V55.18H33.05V26.46ZM51.14 28.73L48 26.46V55.18L51.14 53.63V28.73ZM27.32 15C27.32 17.8 28.95 19.44 31.77 19.45C28.97 19.45 27.33 21.08 27.32 23.9C27.32 21.1 25.69 19.46 22.87 19.45C25.67 19.45 27.31 17.82 27.32 15ZM29.49 22C29.49 24.08 30.7 25.3 32.8 25.31C30.72 25.31 29.5 26.52 29.49 28.62C29.49 26.54 28.28 25.32 26.18 25.31C28.26 25.31 29.48 24.09 29.49 22ZM24.98 21.98C24.98 23.38 25.8 24.2 27.2 24.2C25.8 24.2 24.98 25.02 24.98 26.42C24.98 25.02 24.16 24.2 22.76 24.2C24.16 24.2 24.98 23.38 24.98 21.98Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.4b3ce53c6553d571a7b8a78dc5edc722.svg";
export { ForwardRef as ReactComponent };